// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__NyS-G","gfeWrapper":"CalendarEvent_gfeWrapper__2GkmP"};